import { theme } from '@prophecy/theme';
import { Display, Stack, Text } from '@prophecy/ui-v3';
import styled from 'styled-components';

// Note: colors used in BannerRoot are not from color palette
const BannerRoot = styled(Stack)`
  border-radius: 24px;
  background: linear-gradient(
    227deg,
    #fff7f5 0%,
    #fff3f4 10.5%,
    #fff2f4 22.79%,
    #fff4f4 36.02%,
    #fff8f5 51.14%,
    #fff9f6 66.55%,
    #fff8f3 82.65%,
    #fff5ea 100%
  );
`;

export const PackageBanner = ({
  heading = 'Package Hub',
  subHeading = 'Explore, Collaborate, and Accelerate Your Data Analysis',
  description = 'Discover a rich ecosystem of gems, functions, and pipelines to supercharge your data analysis, powered by\n' +
    '        Prophecy and your organization.'
}: {
  heading?: string;
  subHeading?: string;
  description?: string;
}) => {
  return (
    <BannerRoot padding={theme.spaces.x48} gap={theme.spaces.x12}>
      <Text weight={theme.fontWeight.semiBold} level='sm' tone={theme.colors.orange700}>
        {heading}
      </Text>
      <Display weight={theme.fontWeight.medium} level='xs' tone={theme.colors.gray900}>
        {subHeading}
      </Display>
      <Text level='sm' tone={theme.colors.gray600}>
        {description}
      </Text>
    </BannerRoot>
  );
};
